import { render } from "./stronaKontaDodajOgloszenie.vue?vue&type=template&id=37e33d71&scoped=true"
import script from "./stronaKontaDodajOgloszenie.vue?vue&type=script&lang=js"
export * from "./stronaKontaDodajOgloszenie.vue?vue&type=script&lang=js"

import "./stronaKontaDodajOgloszenie.vue?vue&type=style&index=0&id=37e33d71&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e33d71"]])

export default __exports__